import { useCallback, useContext } from 'react';
import { useActionEffects } from '../utilHooks/useActionEffects';
import { GlobalToastContext } from './GlobalToastProvider';

export type AlertTypes = 'success' | 'info' | 'inprogress' | 'error' | 'warning';

type SuccessMessageType<U> =
  | string
  | { message: string; alertType: AlertTypes }
  | ((result: U) => string | { message: string; alertType: AlertTypes });

export const useToastedAction = <T extends any[], U>(
  action: (...args: T) => Promise<U>,
  successMessage: SuccessMessageType<U>,
  errorMessage?: string
) => {
  const globalToast = useContext(GlobalToastContext);

  const toastSuccess = useCallback(
    (result?: U) => {
      const resolvedMessage = typeof successMessage === 'function' ? successMessage(result as U) : successMessage;
      const msg = typeof resolvedMessage === 'string' ? resolvedMessage : resolvedMessage.message;
      const alertType = typeof resolvedMessage === 'string' ? 'success' : resolvedMessage.alertType;
      globalToast({ message: msg, type: alertType });
    },
    [globalToast, successMessage]
  );

  const toastError = useCallback(
    (error: Error) => {
      globalToast({ message: errorMessage ?? error.message, type: 'error' });
    },
    [errorMessage, globalToast]
  );

  return useActionEffects(action, toastSuccess, toastError);
};
